<template>
  <ItemTransaction
    v-if="isNotificationToRedirect"
    :notification="notification"
    :is-notification-page="isNotificationPage"
  />
  <ItemEmailNotification
    v-else-if="isEmailConfirmNotificaton"
    :notification="notification"
    :is-notification-page="isNotificationPage"
  />
  <ItemDropdown v-else :notification="notification" :is-notification-page="isNotificationPage" />
</template>

<script lang="ts" setup>
import { ENotificationSettingsType, type INotificationFeedElement } from '~/types/notifications';
import ItemDropdown from '../itemDropdown/itemDropdown.vue';
import ItemEmailNotification from '../itemEmailNotification/itemEmailNotification.vue';
import ItemTransaction from '../itemTransaction/itemTransaction.vue';

const props = defineProps({
  notification: {
    type: Object as PropType<INotificationFeedElement>,
    required: true,
  },
  isNotificationPage: {
    type: Boolean,
    default: false,
  },
});

const isNotificationToRedirect = computed(
  () =>
    props.notification.type === ENotificationSettingsType.DepositInfo ||
    props.notification.type === ENotificationSettingsType.CashOut
);

const isEmailConfirmNotificaton = computed(
  () => props.notification.type === ENotificationSettingsType.ConfirmEmail
);
</script>
<style lang="scss" module src="./notificationsListItem.scss"></style>
